const COLORS = [
  "#000000",
  "#1F2937",
  "#2563EB",
  "#0891B2",
  "#DC2626",
  "#16A34A",
  "#7C3AED",
  "#DB2777",
  "#EA580C",
  "#6B7280",
];

export default function ColorRow({ label, value, onChange }) {
  return (
    <div style={{ marginBottom: "1rem" }}>
      {label && (
        <label 
          className="form-label fw-medium text-dark" 
          style={{ marginBottom: "0.5rem" }}
        >
          {label}
        </label>
      )}

      <div 
        className="d-flex align-items-center gap-3" 
        style={{ marginBottom: "1rem" }}
      >
        {/* Color Swatch & Picker Trigger */}
        <div 
          className="position-relative rounded border shadow-sm overflow-hidden flex-shrink-0"
          style={{ 
            width: "2.5rem", 
            height: "2.5rem", 
            cursor: "pointer" 
          }}
        >
          {/* Visual Color Preview */}
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{ 
              backgroundColor: value,
              pointerEvents: "none" 
            }}
          />
          
          {/* Hidden Native Input Trigger */}
          <input
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
            style={{ cursor: "pointer" }}
            title="Choose color"
          />
        </div>

        {/* Hex Text Input */}
        <input
          className="form-control form-control-sm font-monospace"
          style={{ 
            width: "8rem", 
            textTransform: "uppercase" 
          }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
          maxLength={7}
        />
      </div>

      {/* Preset Colors */}
      <div className="d-flex gap-2 flex-wrap">
        {COLORS.map((c) => (
          <button
            key={c}
            type="button"
            className="btn p-0 rounded border"
            style={{
              backgroundColor: c,
              width: "2rem",
              height: "2rem",
              transition: "transform 0.2s",
              border: value === c ? "2px solid #0d6efd" : "1px solid #dee2e6",
              transform: value === c ? "scale(1.05)" : "scale(1)",
              outline: "none",
            }}
            onMouseEnter={(e) => {
              if (value !== c) {
                e.currentTarget.style.transform = "scale(1.1)";
              }
            }}
            onMouseLeave={(e) => {
              if (value !== c) {
                e.currentTarget.style.transform = "scale(1)";
              }
            }}
            onFocus={(e) => {
              e.currentTarget.style.boxShadow = "0 0 0 0.2rem rgba(13, 110, 253, 0.25)";
            }}
            onBlur={(e) => {
              e.currentTarget.style.boxShadow = "none";
            }}
            onClick={() => onChange(c)}
          />
        ))}
      </div>
    </div>
  );
}